'use client';

import { usePathname } from 'next/navigation';
import { useEffect, useRef } from 'react';

declare global {
  interface Window {
    __startGtmPageViewGate?: () => void;
  }
}

/** Fires the page_view gate on initial load and client-side navigations. */
const GTMPageViewGate = () => {
  const pathname = usePathname();
  const previousPathname = useRef<string | undefined>(undefined);

  useEffect(() => {
    if (previousPathname.current === pathname) {
      return;
    }

    previousPathname.current = pathname;
    window.__startGtmPageViewGate?.();
  }, [pathname]);

  return null;
};

export default GTMPageViewGate;
